import React, { useState, useEffect } from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
    TablePagination, TextField, InputAdornment, IconButton, Box, Typography, CircularProgress
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import axios, { decryptData, encryptData } from '../Axiosinstance';
import { useParams } from 'react-router-dom';
import TeachHeader from '../Teacher/TeachHeader';
import { Link, useNavigate } from 'react-router-dom';

const TeacherIntakeDetails = () => {
    const { batchId } = useParams();
    // alert(batchId)
    const [intakeDetails, setIntakeDetails] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        axios.get(`intake-details/batch/${decryptData(decodeURIComponent(batchId))}`)
            .then((response) => {
                setIntakeDetails(response.data);
                setLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setLoading(false);
            });
    }, [batchId]);



    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const filteredDetails = intakeDetails.filter(detail =>
        detail.intakeId.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <Box p={2} display="flex" flexDirection="column" alignItems="center">
            <TeachHeader />
            <Box mt={3} mb={2}>
                <Typography variant="h4" align="center" gutterBottom>
                    Batches Details
                </Typography>
            </Box>
            <Paper elevation={3} style={{ width: '80%', maxWidth: '1200px' }}>
                <Box p={2}>
                    <TextField
                        placeholder="Search by Intake ID"
                        variant="outlined"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <IconButton>
                                        <SearchIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                        fullWidth
                    />
                </Box>
                <TableContainer>
                    {loading ? (
                        <Box display="flex" justifyContent="center" p={3}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell><strong>Intake ID</strong></TableCell>
                                    <TableCell><strong>Start Date</strong></TableCell>
                                    <TableCell><strong>End Date</strong></TableCell>
                                    <TableCell><strong>Manage</strong></TableCell>
                                    {/* <TableCell style={{ width: '20%' }}>Curriculum Manages</TableCell> */}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredDetails.length > 0 ? (
                                    filteredDetails
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((detail) => (
                                            <TableRow key={detail.id}>
                                                <TableCell>{detail.intakeId}</TableCell>
                                                <TableCell>
                                                    {new Date(detail.scheduleDateDetails[0].startDate).toLocaleDateString("en-GB")}
                                                </TableCell>
                                                <TableCell>
                                                    {new Date(detail.scheduleDateDetails[detail.scheduleDateDetails.length - 1].endDate).toLocaleDateString("en-GB")}
                                                </TableCell>
                                                {/* <TableCell>
                                                    <Link to={`/Managebatches/${encodeURIComponent(encryptData(detail.batchId))}/${encodeURIComponent(encryptData(detail.intakeId))}`} style={{ textDecoration: 'none' }}>
                                                        View Batch
                                                    </Link>
                                                </TableCell> */}
                                                <TableCell>
                                                    <Link to={`/Teacherassessment/${encodeURIComponent(encryptData(detail.batchId))}/${encodeURIComponent(encryptData(detail.intakeId))}`} style={{ textDecoration: 'none' }}>
                                                        View Batch
                                                    </Link>
                                                </TableCell>
                                                {/* <TableCell>{detail.contents}<Link to={`/Managec/${detail.batchId}/${detail.intakeId}`} style={{ textDecoration: 'none' }}>
                          View Materials
                        </Link></TableCell> */}
                                                {/* <TableCell>{detail.batchId}</TableCell> */}
                                            </TableRow>
                                        ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={4} align="center">
                                            <Typography variant="body1" color="textSecondary">
                                                No results found.
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    )}
                </TableContainer>
                <TablePagination
                    component="div"
                    count={filteredDetails.length}
                    page={page}
                    onPageChange={handlePageChange}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleRowsPerPageChange}
                    rowsPerPageOptions={[5, 10, 25]}
                />
            </Paper>
        </Box>
    );
};

export default TeacherIntakeDetails;
